// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-month-view {
  display: flex;
  background-color: var(--ids-calendar-month-view-color-background-default);
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  overflow: auto;
  max-width: inherit;
}
.ids-month-view .month-view-container {
  background-color: var(--ids-calendar-month-view-color-background-default);
  flex-shrink: 0;
}
.ids-month-view .month-view-table-header th {
  background-clip: padding-box;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 14.3%;
}
.ids-month-view .month-view-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.ids-month-view .trigger-icon {
  color: var(--ids-color-blue-60);
}
.ids-month-view .month-view-legend {
  margin: 0 auto;
  padding: 10px 5px 0;
}
.ids-month-view .month-view-legend-swatch,
.ids-month-view .month-view-legend-item,
.ids-month-view .month-view-legend-text {
  display: inline-block;
}
.ids-month-view .month-view-legend-item {
  margin-bottom: 2px;
}
.ids-month-view .month-view-legend-swatch {
  background-color: var(--legend-color);
  opacity: 0.3;
  width: 16px;
  height: 16px;
}
.ids-month-view .month-view-legend-item.event-type .month-view-legend-swatch {
  border-radius: 10px;
  opacity: 1;
  width: 14px;
  height: 14px;
}
.ids-month-view .month-view-legend-text {
  position: relative;
  color: var(--ids-calendar-month-view-legend-color-text);
  padding: 0 10px 0 8px;
  top: -2px;
}
.ids-month-view .events-container {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.ids-month-view .events-container .events-overflow {
  position: absolute;
  bottom: 0;
  cursor: pointer;
  text-indent: 12px;
}
.ids-month-view .events-container ids-text::part(text) {
  text-transform: capitalize;
}

.ids-month-view.is-compact {
  position: relative;
}
.ids-month-view.is-compact .month-view-table-header th {
  line-height: unset;
  vertical-align: top;
  height: 22px;
}
.ids-month-view.is-compact .month-view-table {
  margin-top: 13px;
}
.ids-month-view.is-compact .weekday-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact);
}
.ids-month-view.is-compact td {
  width: 44px;
  height: 44px;
  text-align: center;
}
.ids-month-view.is-compact td:not(.is-disabled):hover {
  cursor: pointer;
}
.ids-month-view.is-compact td .day-container {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  border: 1px solid transparent;
  margin: 5px 0;
}
.ids-month-view.is-compact td .day-text {
  display: inline-block;
  position: relative;
  z-index: 2;
  border-radius: 50%;
  margin: 2px;
  color: var(--ids-calendar-month-view-color-text-default);
  white-space: nowrap;
  transition: 0.2s background-color ease;
}
.ids-month-view.is-compact td.alternate .day-text {
  color: var(--ids-calendar-month-view-color-text-compact);
}
.ids-month-view.is-compact td.is-disabled .day-text {
  background-color: var(--ids-color-neutral-10);
  color: var(--ids-color-neutral-30);
}
.ids-month-view.is-compact td.is-disabled.has-legend .day-container::after {
  opacity: 0.4;
}
.ids-month-view.is-compact td.is-disabled.has-legend .day-text {
  background-color: transparent;
}
.ids-month-view.is-compact td ids-text::part(text) {
  border-radius: 50%;
  box-sizing: border-box;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.ids-month-view.is-compact td:hover .day-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact-hover);
}
.ids-month-view.is-compact td.ids-disabled:hover .day-text {
  color: var(--ids-color-gray-30);
}
.ids-month-view.is-compact td.is-selected .day-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact-selected-hover);
  background-color: var(--ids-calendar-month-view-day-color-background-compact-selected);
}
.ids-month-view.is-compact td.is-selected:focus {
  outline: none;
  outline-style: none;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus ids-text::part(text) {
  width: 31px;
  height: 31px;
  line-height: 31px;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus ids-text {
  margin: 2px;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus .day-container {
  border-color: var(--ids-calendar-month-view-day-color-background-compact-selected);
  z-index: 2;
  box-shadow: 0 0 2px 0 var(--ids-calendar-month-view-day-color-background-compact-selected);
}
.ids-month-view.is-compact td.is-today:not(.is-selected) .day-text::part(text) {
  border: 1px solid var(--ids-calendar-month-view-today-color-border-compact);
}
.ids-month-view.is-compact td:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):hover .day-text, .ids-month-view.is-compact td:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):active .day-text {
  background-color: var(--ids-calendar-month-view-day-color-background-compact-hover);
}
.ids-month-view.is-compact td.has-legend:not(.is-disabled):hover .day-container::after {
  opacity: 0.7;
}
.ids-month-view.is-compact td.has-legend .day-container::after {
  border-radius: 50%;
  position: absolute;
  content: "";
  background-color: var(--legend-color);
  display: inline-block;
  width: 35px;
  height: 35px;
  overflow: hidden;
  opacity: 0.3;
  transition: 0.2s opacity ease;
  inset: 0;
  margin: auto;
}
.ids-month-view.is-compact td.range-selection + .range-selection, .ids-month-view.is-compact td.range-next:not(:first-of-type), .ids-month-view.is-compact td.range-prev:not(:last-of-type) {
  position: relative;
}
.ids-month-view.is-compact td.range-selection + .range-selection::before, .ids-month-view.is-compact td.range-next:not(:first-of-type)::before, .ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  position: absolute;
  width: 100%;
  z-index: 1;
  content: "";
  display: inline-block;
  height: 35px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.ids-month-view.is-compact td.is-disabled.range-selection.not-included + .range-selection::before, .ids-month-view.is-compact td.is-disabled.range-prev.not-included::before {
  content: none;
}
.ids-month-view.is-compact td:not(.is-disabled.not-included).range-prev .day-text, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-next .day-text, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-next:not(:first-of-type)::before, .ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  background-color: var(--ids-calendar-month-view-range-color-background-compact);
}
.ids-month-view.is-compact td.range-selection:not(:first-of-type)::before, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-selection .day-text {
  background-color: var(--ids-calendar-month-view-range-color-background-compact-selected);
}
.ids-month-view.is-compact td.range-selection:not(.alternate):not(.is-disabled.not-included) .day-text {
  color: var(--ids-calendar-month-view-range-color-text-compact-selected);
}
.ids-month-view.is-compact td.range-selection:not(:first-of-type)::before, .ids-month-view.is-compact td.range-next:not(:first-of-type)::before {
  right: 50%;
}
.ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  right: -50%;
}
.ids-month-view.is-compact td.range-selection .day-text, .ids-month-view.is-compact td.range-prev .day-text, .ids-month-view.is-compact td.range-next .day-text {
  border-radius: 50%;
  z-index: 2;
  transition: none;
}
.ids-month-view.is-compact th,
.ids-month-view.is-compact td {
  padding: 0;
}
.ids-month-view.is-compact.range-select-week td .day-text {
  transition: none;
}
.ids-month-view.is-compact .btn-today {
  margin-right: -7px;
}
.ids-month-view.is-compact .btn-today::part(button) {
  padding-inline: 4px;
  padding-block: 2px;
  margin: 3px;
}
.ids-month-view.is-compact .btn-previous,
.ids-month-view.is-compact .btn-next {
  padding-inline-start: 0;
  margin: 3px;
}
.ids-month-view.is-compact .btn-previous::part(button),
.ids-month-view.is-compact .btn-next::part(button) {
  padding: 0;
  width: 38px;
  height: 38px;
}
.ids-month-view.is-compact .month-view-legend {
  padding-top: 27px;
  max-width: 300px;
}
.ids-month-view.is-compact .week-num-cell {
  border-inline-end: 1px solid var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-compact .week-num-cell ids-text {
  color: var(--ids-month-view-week-number-text-color);
  cursor: default;
}

.ids-month-view.is-fullsize {
  border-style: solid;
  border-width: 1px 1px 0;
  border-color: var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-fullsize .weekday-text {
  color: var(--ids-calendar-month-view-weekday-color-text);
}
.ids-month-view.is-fullsize.is-disabled.has-legend {
  opacity: 0.4;
  background-color: transparent;
}
.ids-month-view.is-fullsize .day-text {
  color: var(--ids-calendar-month-view-color-text-default);
}
.ids-month-view.is-fullsize td {
  border-style: solid;
  border-width: 0 1px 1px;
  position: relative;
  transition: 0.1s background-color ease-out;
  height: 99px;
  width: 14.3%;
  overflow: hidden;
  user-select: none;
}
.ids-month-view.is-fullsize td:last-child {
  border-right: 0;
}
.ids-month-view.is-fullsize td:first-child {
  border-left: 0;
}
.ids-month-view.is-fullsize td:not(.is-selected):not(.has-legend):not(.is-disabled):hover, .ids-month-view.is-fullsize td:not(.is-selected):not(.has-legend):not(.is-disabled):active {
  background-color: var(--ids-calendar-month-view-color-background-hover);
}
.ids-month-view.is-fullsize td.is-disabled {
  opacity: 0.5;
  background-color: var(--ids-calendar-month-view-color-background-disabled);
}
.ids-month-view.is-fullsize td.is-disabled.has-legend::after {
  opacity: 0.4;
}
.ids-month-view.is-fullsize td.is-selected:not(.has-legend) {
  background-color: var(--ids-calendar-month-view-color-background-selected);
}
.ids-month-view.is-fullsize td.is-selected {
  box-shadow: inset 0 5px 0 0 var(--ids-calendar-month-view-color-selected);
}
.ids-month-view.is-fullsize td.is-selected:focus {
  outline: none;
}
.ids-month-view.is-fullsize td.has-legend::after {
  position: absolute;
  width: 100%;
  background-color: var(--legend-color);
  content: "";
  inset: 0;
  opacity: 0.3;
}
.ids-month-view.is-fullsize td.has-legend.is-selected::after {
  top: 5px;
}
.ids-month-view.is-fullsize td.has-legend:hover::after {
  opacity: 0.7;
}
.ids-month-view.is-fullsize td.alternate .day-text {
  color: var(--ids-calendar-month-view-color-text-alternate);
}
.ids-month-view.is-fullsize td .day-text {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  left: calc(100% - 25px);
  top: var(--ids-month-view-day-text-top, 13px);
  width: 10px;
  text-align: center;
}
.ids-month-view.is-fullsize td.month-label .day-text {
  left: auto;
  width: 100%;
  text-align: right;
}
.ids-month-view.is-fullsize td.month-label ids-text::part(text) {
  font-weight: 600;
  padding-right: 10px;
}
.ids-month-view.is-fullsize th,
.ids-month-view.is-fullsize td {
  padding: 0;
  border-bottom: 1px solid;
  border-color: var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-fullsize.has-legend .month-view-container {
  border-bottom: 1px solid var(--ids-calendar-month-view-color-border);
}

.ids-month-view.is-date-picker {
  overflow: visible;
}
.ids-month-view.is-date-picker .month-view-container {
  padding-left: 10px;
  padding-right: 10px;
}
.ids-month-view.is-date-picker td .day-container {
  margin: 0;
}
.ids-month-view.is-date-picker ids-date-picker {
  margin-left: 12px;
}

.ids-month-view.is-date-picker .month-view-legend,
.ids-month-view.is-fullsize .month-view-legend {
  text-align: center;
}

.month-view-legend-item.event-type .month-view-legend-swatch {
  border-radius: 10px;
  opacity: 1;
}

ids-toolbar ids-menu-button[menu=view-picker] {
  margin-inline-end: 8px;
}

:host([dir=rtl]) .ids-month-view.is-fullsize td .day-text {
  left: unset;
  right: calc(100% - 25px);
}
:host([dir=rtl]) .ids-month-view.is-fullsize td.month-label .day-text {
  right: auto;
  text-align: left;
}
:host([dir=rtl]) .ids-month-view.is-fullsize td.month-label ids-text::part(text) {
  padding-right: unset;
  padding-left: 10px;
}
:host([dir=rtl]) .ids-month-view.is-fullsize td:last-child {
  border-left: 0;
}
:host([dir=rtl]) .ids-month-view.is-date-picker ids-date-picker {
  margin-left: 0;
  margin-right: 12px;
}
:host([dir=rtl]) .ids-month-view.is-date-picker .btn-today {
  margin-right: 0;
  margin-left: -7px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-month-view/ids-month-view.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yEAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AACF;AACE;EACE,yEAAA;EACA,cAAA;AACJ;AAGI;EACE,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AADN;AAKE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;AAHJ;AAME;EACE,+BAAA;AAJJ;AAQE;EACE,cAAA;EACA,mBAAA;AANJ;AASE;;;EAGE,qBAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,qCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AATJ;AAYE;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAVJ;AAaE;EACE,kBAAA;EACA,uDAAA;EACA,qBAAA;EACA,SAAA;AAXJ;AAcE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AAZJ;AAcI;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAZN;AAeI;EACE,0BAAA;AAbN;;AAmBA;EACE,kBAAA;AAhBF;AAkBE;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,gBAAA;AAjBJ;AAoBE;EACE,gEAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,eAAA;AAnBN;AAsBI;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;AApBN;AAuBI;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,wDAAA;EACA,mBAAA;EACA,sCAAA;AArBN;AAwBI;EACE,wDAAA;AAtBN;AA0BM;EACE,6CAAA;EACA,kCAAA;AAxBR;AA4BQ;EACE,YAAA;AA1BV;AA6BQ;EACE,6BAAA;AA3BV;AAgCI;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AA9BN;AAkCM;EACE,sEAAA;AAhCR;AAqCM;EACE,+BAAA;AAnCR;AAwCM;EACE,+EAAA;EACA,sFAAA;AAtCR;AAyCM;EACE,aAAA;EACA,mBAAA;AAvCR;AA2CQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzCV;AA4CQ;EACE,WAAA;AA1CV;AA6CQ;EACE,kFAAA;EACA,UAAA;EACA,0FAAA;AA3CV;AAgDI;EACE,2EAAA;AA9CN;AAiDI;EAEE,mFAAA;AAhDN;AAqDM;EACE,YAAA;AAnDR;AAwDM;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,QAAA;EACA,YAAA;AAtDR;AA2DI;EAGE,kBAAA;AA3DN;AA6DM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AA3DR;AAiEM;EACE,aAAA;AA/DR;AAmEI;EAIE,+EAAA;AApEN;AAuEI;EAEE,wFAAA;AAtEN;AAyEI;EACE,uEAAA;AAvEN;AA0EI;EAEE,UAAA;AAzEN;AA4EI;EACE,WAAA;AA1EN;AA6EI;EAGE,kBAAA;EACA,UAAA;EACA,gBAAA;AA7EN;AAiFE;;EAEE,UAAA;AA/EJ;AAkFE;EACE,gBAAA;AAhFJ;AAmFE;EACE,kBAAA;AAjFJ;AAmFI;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;AAjFN;AAqFE;;EAEE,uBAAA;EACA,WAAA;AAnFJ;AAqFI;;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAlFN;AAsFE;EACE,iBAAA;EACA,gBAAA;AApFJ;AAuFE;EACE,wEAAA;AArFJ;AAuFI;EACE,mDAAA;EACA,eAAA;AArFN;;AA2FA;EACE,mBAAA;EACA,uBAAA;EACA,yDAAA;AAxFF;AA0FE;EACE,wDAAA;AAxFJ;AA2FE;EACE,YAAA;EACA,6BAAA;AAzFJ;AA4FE;EACE,wDAAA;AA1FJ;AA6FE;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0CAAA;EAUA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AApGJ;AAyFI;EACE,eAAA;AAvFN;AA0FI;EACE,cAAA;AAxFN;AAgGI;EAEE,uEAAA;AA/FN;AAkGI;EACE,YAAA;EACA,0EAAA;AAhGN;AAkGM;EACE,YAAA;AAhGR;AAoGI;EACE,0EAAA;AAlGN;AAqGI;EACE,yEAAA;AAnGN;AAqGM;EACE,aAAA;AAnGR;AAwGM;EACE,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AAtGR;AAyGM;EACE,QAAA;AAvGR;AA0GM;EACE,YAAA;AAxGR;AA4GI;EACE,0DAAA;AA1GN;AA6GI;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,6CAAA;EACA,WAAA;EACA,kBAAA;AA3GN;AA8GI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;AA5GN;AA+GI;EACE,gBAAA;EACA,mBAAA;AA7GN;AAiHE;;EAEE,UAAA;EACA,wBAAA;EACA,yDAAA;AA/GJ;AAmHE;EACE,oEAAA;AAjHJ;;AAsHA;EACE,iBAAA;AAnHF;AAqHE;EACE,kBAAA;EACA,mBAAA;AAnHJ;AAsHE;EACE,SAAA;AApHJ;AAuHE;EACE,iBAAA;AArHJ;;AA4HE;;EACE,kBAAA;AAxHJ;;AA6HA;EACE,mBAAA;EACA,UAAA;AA1HF;;AA6HA;EACE,sBAAA;AA1HF;;AAiIM;EACE,WAAA;EACA,wBAAA;AA9HR;AAiIM;EACE,WAAA;EACA,gBAAA;AA/HR;AAkIM;EACE,oBAAA;EACA,kBAAA;AAhIR;AAmIM;EACE,cAAA;AAjIR;AAsIM;EACE,cAAA;EACA,kBAAA;AApIR;AAuIM;EACE,eAAA;EACA,iBAAA;AArIR","sourcesContent":[".ids-month-view {\n  display: flex;\n  background-color: var(--ids-calendar-month-view-color-background-default);\n  width: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  overflow: auto;\n  max-width: inherit;\n\n  .month-view-container {\n    background-color: var(--ids-calendar-month-view-color-background-default);\n    flex-shrink: 0;\n  }\n\n  .month-view-table-header {\n    th {\n      background-clip: padding-box;\n      height: 30px;\n      line-height: 30px;\n      text-align: center;\n      width: 14.3%;\n    }\n  }\n\n  .month-view-table {\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n  }\n\n  .trigger-icon {\n    color: var(--ids-color-blue-60);\n  }\n\n  // Legend mutual\n  .month-view-legend {\n    margin: 0 auto;\n    padding: 10px 5px 0;\n  }\n\n  .month-view-legend-swatch,\n  .month-view-legend-item,\n  .month-view-legend-text {\n    display: inline-block;\n  }\n\n  .month-view-legend-item {\n    margin-bottom: 2px;\n  }\n\n  .month-view-legend-swatch {\n    background-color: var(--legend-color);\n    opacity: 0.3;\n    width: 16px;\n    height: 16px;\n  }\n\n  .month-view-legend-item.event-type .month-view-legend-swatch {\n    border-radius: 10px;\n    opacity: 1;\n    width: 14px;\n    height: 14px;\n  }\n\n  .month-view-legend-text {\n    position: relative;\n    color: var(--ids-calendar-month-view-legend-color-text);\n    padding: 0 10px 0 8px;\n    top: -2px;\n  }\n\n  .events-container {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n\n    .events-overflow {\n      position: absolute;\n      bottom: 0;\n      cursor: pointer;\n      text-indent: 12px;\n    }\n\n    ids-text::part(text) {\n      text-transform: capitalize;\n    }\n  }\n}\n\n// Compact view\n.ids-month-view.is-compact {\n  position: relative;\n\n  .month-view-table-header th {\n    line-height: unset;\n    vertical-align: top;\n    height: 22px;\n  }\n\n  .month-view-table {\n    margin-top: 13px;\n  }\n\n  .weekday-text {\n    color: var(--ids-calendar-month-view-weekday-color-text-compact);\n  }\n\n  td {\n    width: 44px;\n    height: 44px;\n    text-align: center;\n\n    &:not(.is-disabled):hover {\n      cursor: pointer;\n    }\n\n    .day-container {\n      display: inline-block;\n      position: relative;\n      border-radius: 50%;\n      border: 1px solid transparent;\n      margin: 5px 0;\n    }\n\n    .day-text {\n      display: inline-block;\n      position: relative;\n      z-index: 2;\n      border-radius: 50%;\n      margin: 2px;\n      color: var(--ids-calendar-month-view-color-text-default);\n      white-space: nowrap;\n      transition: 0.2s background-color ease;\n    }\n\n    &.alternate .day-text {\n      color: var(--ids-calendar-month-view-color-text-compact);\n    }\n\n    &.is-disabled {\n      .day-text {\n        background-color: var(--ids-color-neutral-10);\n        color: var(--ids-color-neutral-30);\n      }\n\n      &.has-legend {\n        .day-container::after {\n          opacity: 0.4;\n        }\n\n        .day-text {\n          background-color: transparent;\n        }\n      }\n    }\n\n    ids-text::part(text) {\n      border-radius: 50%;\n      box-sizing: border-box;\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      text-align: center;\n      display: inline-block;\n    }\n\n    &:hover {\n      .day-text {\n        color: var(--ids-calendar-month-view-weekday-color-text-compact-hover);\n      }\n    }\n\n    &.ids-disabled:hover {\n      .day-text {\n        color: var(--ids-color-gray-30);\n      }\n    }\n\n    &.is-selected {\n      .day-text {\n        color: var(--ids-calendar-month-view-weekday-color-text-compact-selected-hover);\n        background-color: var(--ids-calendar-month-view-day-color-background-compact-selected);\n      }\n\n      &:focus {\n        outline: none;\n        outline-style: none;\n      }\n\n      &:not(.is-disabled):not(.range-selection):focus {\n        ids-text::part(text) {\n          width: 31px;\n          height: 31px;\n          line-height: 31px;\n        }\n\n        ids-text {\n          margin: 2px;\n        }\n\n        .day-container {\n          border-color: var(--ids-calendar-month-view-day-color-background-compact-selected);\n          z-index: 2;\n          box-shadow: 0 0 2px 0 var(--ids-calendar-month-view-day-color-background-compact-selected);\n        }\n      }\n    }\n\n    &.is-today:not(.is-selected) .day-text::part(text) {\n      border: 1px solid var(--ids-calendar-month-view-today-color-border-compact);\n    }\n\n    &:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):hover .day-text,\n    &:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):active .day-text {\n      background-color: var(--ids-calendar-month-view-day-color-background-compact-hover);\n    }\n\n    // Legend in compact mode\n    &.has-legend:not(.is-disabled):hover {\n      .day-container::after {\n        opacity: 0.7;\n      }\n    }\n\n    &.has-legend .day-container {\n      &::after {\n        border-radius: 50%;\n        position: absolute;\n        content: '';\n        background-color: var(--legend-color);\n        display: inline-block;\n        width: 35px;\n        height: 35px;\n        overflow: hidden;\n        opacity: 0.3;\n        transition: 0.2s opacity ease;\n        inset: 0;\n        margin: auto;\n      }\n    }\n\n    // Range selection\n    &.range-selection + .range-selection,\n    &.range-next:not(:first-of-type),\n    &.range-prev:not(:last-of-type) {\n      position: relative;\n\n      &::before {\n        position: absolute;\n        width: 100%;\n        z-index: 1;\n        content: '';\n        display: inline-block;\n        height: 35px;\n        top: 0;\n        bottom: 0;\n        margin-top: auto;\n        margin-bottom: auto;\n      }\n    }\n\n    &.is-disabled.range-selection.not-included + .range-selection,\n    &.is-disabled.range-prev.not-included {\n      &::before {\n        content: none;\n      }\n    }\n\n    &:not(.is-disabled.not-included).range-prev .day-text,\n    &:not(.is-disabled.not-included).range-next .day-text,\n    &:not(.is-disabled.not-included).range-next:not(:first-of-type)::before,\n    &.range-prev:not(:last-of-type)::before {\n      background-color: var(--ids-calendar-month-view-range-color-background-compact);\n    }\n\n    &.range-selection:not(:first-of-type)::before,\n    &:not(.is-disabled.not-included).range-selection .day-text {\n      background-color: var(--ids-calendar-month-view-range-color-background-compact-selected);\n    }\n\n    &.range-selection:not(.alternate):not(.is-disabled.not-included) .day-text {\n      color: var(--ids-calendar-month-view-range-color-text-compact-selected);\n    }\n\n    &.range-selection:not(:first-of-type)::before,\n    &.range-next:not(:first-of-type)::before {\n      right: 50%;\n    }\n\n    &.range-prev:not(:last-of-type)::before {\n      right: -50%;\n    }\n\n    &.range-selection .day-text,\n    &.range-prev .day-text,\n    &.range-next .day-text {\n      border-radius: 50%;\n      z-index: 2;\n      transition: none;\n    }\n  }\n\n  th,\n  td {\n    padding: 0;\n  }\n\n  &.range-select-week td .day-text {\n    transition: none;\n  }\n\n  .btn-today {\n    margin-right: -7px;\n\n    &::part(button) {\n      padding-inline: 4px;\n      padding-block: 2px;\n      margin: 3px;\n    }\n  }\n\n  .btn-previous,\n  .btn-next {\n    padding-inline-start: 0;\n    margin: 3px;\n\n    &::part(button) {\n      padding: 0;\n      width: 38px;\n      height: 38px;\n    }\n  }\n\n  .month-view-legend {\n    padding-top: 27px;\n    max-width: 300px;\n  }\n\n  .week-num-cell {\n    border-inline-end: 1px solid var(--ids-calendar-month-view-color-border);\n\n    ids-text {\n      color: var(--ids-month-view-week-number-text-color);\n      cursor: default;\n    }\n  }\n}\n\n// Full size view\n.ids-month-view.is-fullsize {\n  border-style: solid;\n  border-width: 1px 1px 0;\n  border-color: var(--ids-calendar-month-view-color-border);\n\n  .weekday-text {\n    color: var(--ids-calendar-month-view-weekday-color-text);\n  }\n\n  &.is-disabled.has-legend {\n    opacity: 0.4;\n    background-color: transparent;\n  }\n\n  .day-text {\n    color: var(--ids-calendar-month-view-color-text-default);\n  }\n\n  td {\n    border-style: solid;\n    border-width: 0 1px 1px;\n    position: relative;\n    transition: 0.1s background-color ease-out;\n\n    &:last-child {\n      border-right: 0;\n    }\n\n    &:first-child {\n      border-left: 0;\n    }\n\n    height: 99px;\n    width: 14.3%;\n    overflow: hidden;\n    user-select: none;\n\n    &:not(.is-selected):not(.has-legend):not(.is-disabled):hover,\n    &:not(.is-selected):not(.has-legend):not(.is-disabled):active {\n      background-color: var(--ids-calendar-month-view-color-background-hover);\n    }\n\n    &.is-disabled {\n      opacity: 0.5;\n      background-color: var(--ids-calendar-month-view-color-background-disabled);\n\n      &.has-legend::after {\n        opacity: 0.4;\n      }\n    }\n\n    &.is-selected:not(.has-legend) {\n      background-color: var(--ids-calendar-month-view-color-background-selected);\n    }\n\n    &.is-selected {\n      box-shadow: inset 0 5px 0 0 var(--ids-calendar-month-view-color-selected);\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    &.has-legend {\n      &::after {\n        position: absolute;\n        width: 100%;\n        background-color: var(--legend-color);\n        content: '';\n        inset: 0;\n        opacity: 0.3;\n      }\n\n      &.is-selected::after {\n        top: 5px;\n      }\n\n      &:hover::after {\n        opacity: 0.7;\n      }\n    }\n\n    &.alternate .day-text {\n      color: var(--ids-calendar-month-view-color-text-alternate);\n    }\n\n    .day-text {\n      position: absolute;\n      cursor: pointer;\n      z-index: 1;\n      left: calc(100% - 25px);\n      top: var(--ids-month-view-day-text-top, 13px);\n      width: 10px;\n      text-align: center;\n    }\n\n    &.month-label .day-text {\n      left: auto;\n      width: 100%;\n      text-align: right;\n    }\n\n    &.month-label ids-text::part(text) {\n      font-weight: 600;\n      padding-right: 10px;\n    }\n  }\n\n  th,\n  td {\n    padding: 0;\n    border-bottom: 1px solid;\n    border-color: var(--ids-calendar-month-view-color-border);\n  }\n\n  // Legend in full size mode\n  &.has-legend .month-view-container {\n    border-bottom: 1px solid var(--ids-calendar-month-view-color-border);\n  }\n}\n\n// Used in a day picker\n.ids-month-view.is-date-picker {\n  overflow: visible;\n\n  .month-view-container {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  td .day-container {\n    margin: 0;\n  }\n\n  ids-date-picker {\n    margin-left: 12px;\n  }\n}\n\n// Legend for full size view and if it's in a datepicker\n.ids-month-view.is-date-picker,\n.ids-month-view.is-fullsize {\n  .month-view-legend {\n    text-align: center;\n  }\n}\n\n// Legend for month\n.month-view-legend-item.event-type .month-view-legend-swatch {\n  border-radius: 10px;\n  opacity: 1;\n}\n\nids-toolbar ids-menu-button[menu='view-picker'] {\n  margin-inline-end: 8px;\n}\n\n// Text direction\n:host([dir='rtl']) {\n  .ids-month-view {\n    &.is-fullsize td {\n      .day-text {\n        left: unset;\n        right: calc(100% - 25px);\n      }\n\n      &.month-label .day-text {\n        right: auto;\n        text-align: left;\n      }\n\n      &.month-label ids-text::part(text) {\n        padding-right: unset;\n        padding-left: 10px;\n      }\n\n      &:last-child {\n        border-left: 0;\n      }\n    }\n\n    &.is-date-picker {\n      ids-date-picker {\n        margin-left: 0;\n        margin-right: 12px;\n      }\n\n      .btn-today {\n        margin-right: 0;\n        margin-left: -7px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
